import { routes } from './routes'

export const documentsRoutes = [
  { route: routes.ABOUT_US, text: 'About Us' },
  { route: routes.VIRTUAL_ITEMS_POLICY, text: 'Terms and Policies' },
  { route: routes.TERM_OF_USE, text: 'Terms of Use' },
  { route: routes.PRIVACY_POLICY, text: 'Privacy policy' },
  { route: routes.ADD_GUIDE, text: 'Advertising policy' },
]
